import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

export default function Loading() {
  return (
    <CircularProgress
      color="secondary"
      size="2rem"
      sx={{ p: 0.5 }}
    />
  );
}
